<template>
  <div>
    <iframe style="width: 100%;height: 800px" :src="iframesrc">


    </iframe>

  </div>
</template>

<script>/**

 **/
import apiAdmin from "@/taylorCommon/apiAdmin";
import {Setting_QueryType_SiteUrl} from "@/views/fireGods/js/fireGodsDeclare";

export default {
  data: function () {
    return {
      datas:[
     ],
      iframesrc:"",
    };
  },
  methods: {
    async loadData() {
      let settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SiteUrl);
      this.iframesrc=settingValue.data.data + "/laravel-filemanager";
      // this.iframesrc="http://127.0.0.1:8000/laravel-filemanager";
    }
  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
